import values from 'lodash/values';
import PropTypes from 'prop-types';
import React from 'react';

import QATags from '../../../../constants/QATags';
import { handlerNoPropagate } from '../../../../lib/EventUtils';
import { createBEM } from '../../../../lib/utils/css';

import './RowItemRightColumnChild.scss';

const RowItemRightColumnChild = React.memo(props => {
  if (!props.rightColChild && !props.rightColChildHover) {
    return null;
  }

  const {
    sourceCardMenuItems,
    isInteractive,
    isRightColPersistent,
    rightColChild,
    qaRightColChild,
    onClick,
    rightColChildHover,
    mainText,
    onFocus,
    onBlur,
    useDarkTheme,
    isRowHovered,
  } = props;
  const isSourceCardEllipsis = isInteractive && sourceCardMenuItems;
  const classes = createBEM('RowItemRightColumnChild', {
    hoverable: onClick,
    hidden: isSourceCardEllipsis,
    action: isInteractive,
    persistent: isRightColPersistent,
    dark: useDarkTheme,
    hovered: isRowHovered,
  });
  const onRightColChildClick = onClick ? handlerNoPropagate(onClick) : null;

  return (
    <div className={classes} data-qa={qaRightColChild} onClick={onRightColChildClick} role='button'>
      {rightColChildHover && (
        <button
          type='button'
          className={classes}
          data-qa={qaRightColChild}
          onFocus={onFocus}
          onBlur={onBlur}
          onClick={onRightColChildClick}
        >
          <span className='visuallyHidden'>{mainText}</span>
          {rightColChildHover}
        </button>
      )}
      <span
        className={
          rightColChildHover
            ? 'RowItemRightColumnChild--hidden-rollover'
            : 'RowItemRightColumnChild--default'
        }
      >
        {rightColChild}
      </span>
    </div>
  );
});

RowItemRightColumnChild.propTypes = {
  isInteractive: PropTypes.bool,
  isRightColPersistent: PropTypes.bool,
  isRowHovered: PropTypes.bool,
  mainText: PropTypes.string,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  qaRightColChild: PropTypes.oneOf(values(QATags)),
  rightColChild: PropTypes.node,
  rightColChildHover: PropTypes.node,
  sourceCardMenuItems: PropTypes.array,
  useDarkTheme: PropTypes.bool,
};

export default RowItemRightColumnChild;
